import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { Grid } from 'semantic-ui-react';
import Color from './components/Color';
import Image from './components/Image';
import Pattern from './components/Pattern';
import Texture from './components/Texture';
import { ChildrenPropType } from '../../services/proptypes';
import './Background.css';
var defaultProps = {
  children: null
};
function Background(_ref) {
  var children = _ref.children,
    gridProps = _objectWithoutProperties(_ref, _excluded);
  if (React.Children.count(children) === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Grid, gridProps, children);
}
Background.defaultProps = defaultProps;
Background.Image = Image;
Background.Color = Color;
Background.Pattern = Pattern;
Background.Texture = Texture;
export default Background;